import { PropsWithChildren } from 'react';
import { useErrorHandler } from 'react-error-boundary';
import { QueryClientProvider, QueryClient, QueryCache } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';

export function ProvideQueryClient({ children }: PropsWithChildren<{}>) {
    const handleError = useErrorHandler();

    const queryClient = new QueryClient({
        queryCache: new QueryCache({
            onError: error => {
                handleError(error);
            },
        }),
    });
    return (
        <QueryClientProvider client={queryClient}>
            <>
                {children}
                <ReactQueryDevtools initialIsOpen={false} />
            </>
        </QueryClientProvider>
    );
}
